import React, { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import useFetch from "../../../hooks/useFetch";

import { getmediaList } from "../../../services/mediaService";
// import { addToCart } from "@/redux/cartSlice";
import ProductLoader from "../../../components/common/ProductLoader";
import MediaCard from "./MediaCard";
import { useSelector } from "react-redux";
import { addToCartProduct } from "../../../services/cartService";
import { setCartDetails } from "../../../redux/slice/cartSlice";
import Button from "../../../components/form/Button";
import Pagination from "../../../components/common/Pagination";
import { useNavigate } from "react-router-dom";

const UserMedia = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state?.profile?.data);
  const isLogin = !!user?._id;
  const [selectedItems, setSelectedItems] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const { data: mediaData, isLoading } = useFetch({
    enabled: true,
    dependencies: ["mediaList", page],
    fetchFunction: async () => {
      try {
        const res = await getmediaList({ page });
        if (res?.docs?.status !== 200) {
          toast.warning(res?.docs?.message || "Failed to fetch media.");
          return [];
        }
        setTotalPages(res?.docs?.metadata?.totalPages || 1);
        // Flatten: include parentMedia as separate items
        return res?.docs?.data || [];
      } catch (error) {
        toast.error("Failed to fetch media.");
        return [];
      }
    },
  });

  const toggleSelect = (mediaItem) => {
    const alreadySelected = selectedItems.find((i) => i._id === mediaItem._id);
    if (alreadySelected) {
      setSelectedItems((prev) => prev.filter((i) => i._id !== mediaItem._id));
    } else {
      setSelectedItems((prev) => [...prev, mediaItem]);
    }
  };
  // Add-to-cart action
  // const handleAddToCart = async (mediaItem) => {
  //   if (!isLogin) {
  //     toast.warning("Please log in first.");
  //     return;
  //   }

  //   try {
  //     const res = await addToCartProduct({
  //       product: mediaItem?._id,
  //       quantity: 1,
  //     });
  //     console.log(res?.data?.data, "carting");
  //     if (res?.data?.status === 200) {
  //       toast.success(res?.data?.message);
  //       dispatch(setCartDetails(res?.data?.data?.[0]));
  //     } else {
  //       toast.error(res?.message || "Failed to add to cart.");
  //     }
  //   } catch (err) {
  //     toast.error("Something went wrong while adding to cart.");
  //   }
  // };
  const handleBulkAddToCart = async () => {
    if (!isLogin) {
      toast.warning("Please log in first.");
      return;
    }

    if (selectedItems.length === 0) {
      toast.warning("Please select at least one image.");
      return;
    }

    const products = selectedItems.map((item) => ({
      product: item._id,
      // productName: item?.name || "Untitled",
      quantity: 1,
    }));

    try {
      const res = await addToCartProduct({ products });
      if (res?.data?.status === 200) {
        toast.success(res?.data?.message || "Images added to cart!");
        dispatch(setCartDetails(res?.data?.data?.[0]));
        setSelectedItems([]);
        navigate("/cart");
      } else {
        toast.error(res?.message || "Failed to add to cart.");
      }
    } catch (err) {
      toast.error("Something went wrong.");
    }
  };

  // const actions = useMemo(() => {
  //   return [
  //     {
  //       _id: 2,
  //       icon: "fa-light fa-bag-shopping",
  //       isLink: false,
  //       click: handleAddToCart,
  //     },
  //   ];
  // }, [isLogin]);

  //   console.log(mediaData);
  const cartItems = useSelector(
    (state) => state?.cart?.cartListData?.data || []
  );
  const cartCount = cartItems.length;

  return (
    <div className="">
      {isLoading ? (
        <div className="grid xl:grid-cols-4 md:grid-cols-3 grid-cols-2 xl:gap-8 md:gap-8 gap-5 md:pt-14 pt-10">
          {Array.from({ length: 8 }).map((_, i) => (
            <ProductLoader key={i} />
          ))}
        </div>
      ) : mediaData?.length > 0 ? (
        <>
          <div className="mb-4 flex justify-end">
            <Button
              buttonLabel="Add to cart"
              buttonFunction={handleBulkAddToCart}
              isDisable={selectedItems.length === 0}
              buttonClasses="!bg-md-pink !text-white !rounded !px-6 !py-2 hover:!bg-md-pink-dark"
            />
          </div>
          <div className="grid xl:grid-cols-4 md:grid-cols-3 grid-cols-2 xl:gap-8 md:gap-8 gap-5">
            {mediaData.map((item) => (
              <MediaCard
                key={item._id}
                data={item}
                // actions={actions}
                selectable
                isSelected={selectedItems.some((i) => i._id === item._id)}
                onSelectChange={toggleSelect}
              />
            ))}
          </div>
          {totalPages > 1 && (
            <div className="pt-6">
              <Pagination
                pageCount={totalPages}
                currentPage={page - 1}
                onPageChange={({ selected }) => {
                  setPage(selected + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            </div>
          )}
        </>
      ) : null}
    </div>
  );
};

export default UserMedia;
